import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { RoomPlanSpatialView } from '~/components/room-plan/room-plan-spatial-view'
import { titleFor } from '~/lib/route-title'
import {
  decodeRoomPlanSpatialSearch,
  type RoomPlanSpatialSearch,
} from '~convex/lib/roomPlanDeepLink'

export const Route = createFileRoute(
  '/_authenticated/$workspaceSlug/projects/$projectId_/scans/$scanId'
)({
  component: SpatialScanRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Room scan`) }] }),
  validateSearch: (search: Record<string, unknown>): RoomPlanSpatialSearch =>
    decodeRoomPlanSpatialSearch(search),
})

function SpatialScanRoute() {
  const { projectId, scanId, workspaceSlug } = Route.useParams()
  const target = Route.useSearch()
  return (
    <RoomPlanSpatialView
      projectId={projectId}
      scanId={scanId}
      target={target}
      workspaceSlug={workspaceSlug}
    />
  )
}
